<template>
  <v-app id="app">
    <v-app-bar
      app
      color="primary"
      dark
    >
    <HistoryDownloader />
    <v-spacer></v-spacer>
    <v-checkbox @change="refresh_check"></v-checkbox>
    <Login v-model="global.login"/>
    </v-app-bar>


    <v-main>
      <v-container fluid>
        <router-view :global="global" v-if="global.login"/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Login from './components/Login';
import HistoryDownloader from './components/HistoryDownloader.vue';

export default {
  name: 'App',

  components: {
    Login,
    HistoryDownloader
},

  methods: {
    refresh_check(e) {
      if (e)
        this.global.refresh = 1800
      else
        this.global.refresh = -1
    },
    isAdmin() {
      return 'ADMIN' == localStorage.getItem('_session_role_')
    }
  },

  data: () => ({
    global: {
      login: false,
      refresh: -1,
    },
  }),
};
</script>